// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"478cf8b4","455":"8aadb14f","977":"905daae1"}[chunkId] + ".chunk.js";
};